export default __webpack_public_path__ + "static/media/attendance.cb26c713.jpg";